import React, { Fragment, useState } from "react";
import { connect } from "react-redux";
import customConfig from "../../config";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import AppIconButton from "../Common/Button/IconButton";
import {
  SectionHeading,
  SectionSubHeading,
  ValueText,
  InfoPairLabel,
  InfoPairValue,
} from "../Common/Typography/AppTypography";

const ServiceInfo = ({
  products,
  showProductInfo,
  WarrantyData: { warrantyDetails },
  serviceError,
  showHeader = true,
}) => {
  const [selectedProduct, setSelectedProduct] = useState(
    products && products.length > 0 ? products[0] : null
  );
  const [selectedServices, setSelectedServices] = useState(
    products &&
      products.length > 0 &&
      warrantyDetails &&
      warrantyDetails[products[0].id] &&
      warrantyDetails[products[0].id].services
      ? warrantyDetails[products[0].id].services
      : null
  );

  const changeTab = (p) => {
    setSelectedProduct(p);
    setSelectedServices(warrantyDetails[p.id].services);
  };

  const uniqueBoxSx = { mb: 1.25 };

  return (
    <Fragment>
      {!serviceError ? (
        <Box>
          {showHeader && (
            <Box sx={{ textAlign: "center", py: 3 }}>
              <SectionHeading sx={{ mb: 0 }}>
                View Service Requests
              </SectionHeading>
            </Box>
          )}
          <Box sx={{ px: 2, pb: 2 }}>
            {showProductInfo && products && products.length > 0 && (
              <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
                {products.map((product) => (
                  <AppIconButton
                    key={product.id}
                    variant="ghost"
                    size="medium"
                    tooltip={product?.product_name || ""}
                    onClick={() => changeTab(product)}
                    icon={<img src={product.icon} alt="" style={{ width: 32, height: 32 }} />}
                    sx={{
                      p: 1,
                      border: "2px solid",
                      borderColor: selectedProduct?.id === product.id ? "primary.main" : "divider",
                      borderRadius: 1,
                      "&:hover": { bgcolor: "action.hover" },
                    }}
                  />
                ))}
              </Box>
            )}
            <Box>
              {showProductInfo && (
                <Grid2 container spacing={2} alignItems="center" sx={{ mb: 2 }}>
                  <Grid2 size={{ xs: 12, sm: 5 }}>
                    <Box {...uniqueBoxSx}>
                      <InfoPairLabel>Product Category</InfoPairLabel>
                      <InfoPairValue>
                        {selectedProduct?.product_name}
                      </InfoPairValue>
                    </Box>
                    <Box {...uniqueBoxSx}>
                      <InfoPairLabel>Modal Name</InfoPairLabel>
                      <InfoPairValue>
                        {selectedProduct?.model_name}
                      </InfoPairValue>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 5 }}>
                    <Box {...uniqueBoxSx}>
                      <InfoPairLabel>Sub Category</InfoPairLabel>
                      <InfoPairValue>
                        {selectedProduct?.sub_product_name}
                      </InfoPairValue>
                    </Box>
                    <Box {...uniqueBoxSx}>
                      <InfoPairLabel>Serial Number</InfoPairLabel>
                      <InfoPairValue>
                        {selectedProduct?.serial_no}
                      </InfoPairValue>
                    </Box>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 2 }}>
                    {selectedProduct?.image && (
                      <Box component="img" src={selectedProduct.image} alt="" sx={{ maxWidth: "100%", height: "auto" }} />
                    )}
                  </Grid2>
                </Grid2>
              )}
              <Box sx={{ pb: 2 }}>
                {selectedServices && selectedServices.length > 0 ? (
                  selectedServices.map((service) => (
                    <Box
                      key={service?.ASCJobId}
                      sx={{
                        mb: 2,
                        p: 2,
                        border: "1px solid rgba(0,0,0,0.12)",
                        borderRadius: 1,
                        bgcolor: "rgba(0,0,0,0.02)",
                      }}
                    >
                      <SectionSubHeading sx={{ fontWeight: 600, color: "text.primary", mb: 1.5 }}>
                        ASC Job ID : {service.ASCJobId}
                      </SectionSubHeading>
                      <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Box {...uniqueBoxSx}>
                            <InfoPairLabel>Job Classification</InfoPairLabel>
                            <InfoPairValue>{service.JobClassification}</InfoPairValue>
                          </Box>
                          <Box {...uniqueBoxSx}>
                            <InfoPairLabel>Job Status</InfoPairLabel>
                            <InfoPairValue>{service.JobStatusName}</InfoPairValue>
                          </Box>
                          <Box {...uniqueBoxSx}>
                            <InfoPairLabel>Job Creation Date</InfoPairLabel>
                            <InfoPairValue>{service.JobCreationDate}</InfoPairValue>
                          </Box>
                          <Box {...uniqueBoxSx}>
                            <InfoPairLabel>Job Remarks</InfoPairLabel>
                            <InfoPairValue>{service.JobRemarks}</InfoPairValue>
                          </Box>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6 }}>
                          <Box {...uniqueBoxSx}>
                            <InfoPairLabel>Job Number</InfoPairLabel>
                            <InfoPairValue>{service.JobNumber}</InfoPairValue>
                          </Box>
                          <Box {...uniqueBoxSx}>
                            <InfoPairLabel>Registered By</InfoPairLabel>
                            <InfoPairValue>{service.RegisteredBy}</InfoPairValue>
                          </Box>
                          <Box {...uniqueBoxSx}>
                            <InfoPairLabel>Job Closing Date</InfoPairLabel>
                            <InfoPairValue>{service.JobClosingDate}</InfoPairValue>
                          </Box>
                        </Grid2>
                      </Grid2>
                    </Box>
                  ))
                ) : (
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "rgba(211, 47, 47, 0.08)",
                      borderRadius: 1,
                      border: "1px solid rgba(211, 47, 47, 0.3)",
                    }}
                  >
                    <ValueText color="error">
                      {customConfig.noServiceRequestMsg}
                    </ValueText>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          {showHeader && (
            <Box sx={{ textAlign: "center", py: 3 }}>
              <SectionHeading sx={{ mb: 0 }}>
                Service Details
              </SectionHeading>
            </Box>
          )}
          <Box sx={{ p: 2 }}>
            <Box
              sx={{
                p: 2,
                bgcolor: "rgba(211, 47, 47, 0.08)",
                borderRadius: 1,
                border: "1px solid rgba(211, 47, 47, 0.3)",
              }}
            >
              <ValueText color="error">
                {serviceError}
              </ValueText>
            </Box>
          </Box>
        </Box>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  WarrantyData: state.warranty,
});

export default connect(mapStateToProps)(ServiceInfo);
